<template>
	<div class="form-reply" :class="{'form-reply-root': !replyId}">
    <div v-if="!replyId">
      <div class="avatar">
        <img v-if="user" :src="user.avatar ? user.avatar : '/static/img/no-avatar.png'" :alt="user.nickname">
        <img v-else src="/static/img/no-avatar.png" />
      </div>
    </div>
    <div class="at-user" v-if="atUser">
      @{{atUser}}
    </div>
    <div class="form-group">
      <el-input
        type="textarea"
        placeholder="请填评论内容..."
        v-model="content"
        :autosize="{ minRows: 3, maxRows: 6}"
        @keydown.meta.enter.native="post"
      >
      </el-input>
      <div v-if="!replyId && !user" class="nologin">
        您还没有登录，<a href="" @click.prevent="login">请登录</a> 
      </div>
    </div>
    <div class="form-group form-action">
      <span class="input-length">当前已输入 {{content.length}} 个字符</span>
      <el-button type="primary" size="medium" :loading="loading" @click.prevent="post">{{btnText}}</el-button>
    </div>
  </div>
</template>

<script>
export default {
	props: ['refType', 'refId', 'replyId', 'atUser'],
  name: 'Post',
  data() {
    return {
      user: undefined,
      content: '',
      btnText: this.replyId ? '回复' : '发表',
      loading: false
    }
  },
  directives: {
    'focus': {
      inserted: function (el) {
        el.focus()
      }
    }
  },
  methods: {
    post() {
      this.$message.closeAll()

      let user = this.$store.getters.user
      if (!user) {
        return this.util.$emit('login')
      }

      if (!this.content) {
        return this.$message.error('请输入评论内容')
      }
      
      let params = {
        refType: this.refType,
        refId: this.refId,
        replyId: this.replyId,
        atUser: this.atUser,
        token: user.token,
        content: this.content
      }

      this.loading = true
      this.axios
        .post(this.axios.apiGateway + "comment/post", params)
        .then(res => {
          if (res.data.errcode) {
            this.$message.error(res.data.errmsg)
          } else {
            this.util.$emit('reloadCommentList', (this.replyId ? 0 : 1), (res) => {
              this.content = ''
              this.$emit('hidePost')
              this.$message.success('评论发表成功！')
            })
          }
          this.loading = false
        });
    },
    login() {
      this.util.$emit('login')
    }
  },
  created() {
    this.$store.dispatch('notify', (user) => {
      this.user = user
    })
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Comment/Post.vue